import script from "./Compliance.vue?vue&type=script&setup=true&lang=js"
export * from "./Compliance.vue?vue&type=script&setup=true&lang=js"

import "./Compliance.vue?vue&type=style&index=0&id=259ffc28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259ffc28"]])

export default __exports__